const accountDetails = {
  accountDetails: {
    managePreferences: '環境設定の管理',
    email: 'メール',
    emailChangeText: '引き続き、メールの変更を確認する必要があります!',
    confirmationText:
      '%{email} に確認メールを送信しました。メールの変更を有効にするには、そのメッセージ内のリンクをクリックする必要があります。',
    resendConfirmationEmail: '確認メールを再送する',
    cancelChange: 'この変更を取り消す',
    firstName: '名',
    lastName: '姓',
    phone: '電話番号',
    company: '会社',
    saveDetails: 'アカウント詳細の保存',
    changeEmailRequest: 'メールの変更',
    //TODO - new translations added
    apiKey: 'API キー',
    generate: '生成する',
    apiKeySubtext: 'このAPIトークンを使用して、当社のAPIをお客様のサードパーティソリューションに安全に統合することができます。',
    //TODO ends
    job_profile: {
      label: "会社での職務プロファイルを選択",
      tooltip_msg: "その人の主な職務プロファイルを選択します。ユーザーが複数の主役職を持っている場合は、「その他」を選択します。",
    }
  },
  resetPassword: {
    instructions:
      'パスワードは 6 文字以上で、数字または特殊文字を 1 文字以上含んでいる必要があります。メールアドレスと同じにすることはできません。',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワードの確認'
  }
};

export default accountDetails;
